
import { supabase } from "@/integrations/supabase/client";
import { fetchCategoryMappings, resolveCategoryId } from "./categoryMappingUtils";
import { ImportResult } from "./importTypes";

/**
 * Imports prompts from Excel file
 */
export const importPromptsFromExcel = async (
  data: Array<{
    title: string;
    description: string;
    content: string;
    category_id: string;
  }>,
  userId: string
): Promise<ImportResult> => {
  try {
    const categoryMapping = await fetchCategoryMappings();
    
    const result: ImportResult = {
      success: false,
      imported: 0,
      failed: 0,
      errors: []
    };
    
    const promptsToInsert = [];
    
    for (const promptData of data) {
      try {
        let categoryId = resolveCategoryId(promptData.category_id, categoryMapping);
        
        if (!categoryId) {
          result.errors.push(`Could not find category match for: ${promptData.category_id} in prompt: ${promptData.title}`);
          result.failed++;
          continue;
        }
        
        promptsToInsert.push({
          title: promptData.title,
          description: promptData.description,
          content: promptData.content,
          category_id: categoryId,
          user_id: userId,
          status: 'approved'
        });
      } catch (err: any) {
        result.errors.push(`Error processing prompt ${promptData.title}: ${err.message}`);
        result.failed++;
      }
    }
    
    // Insert prompts in batches
    const batchSize = 10;
    for (let i = 0; i < promptsToInsert.length; i += batchSize) {
      const batch = promptsToInsert.slice(i, i + batchSize);
      const { error } = await supabase.from('prompts').insert(batch);
      
      if (error) {
        result.errors.push(`Error inserting batch ${i/batchSize + 1}: ${error.message}`);
        result.failed += batch.length;
      } else {
        result.imported += batch.length;
      }
    }
    
    result.success = result.imported > 0;
    return result;
    
  } catch (error: any) {
    console.error('Error importing prompts:', error);
    return {
      success: false,
      imported: 0,
      failed: data.length,
      errors: [error.message]
    };
  }
};
